module.exports = __webpack_public_path__ + "static/media/emot1_on.cec9526c.svg";